import baseUrl from '../baseUrl'
import api from '../axios'

export default {
  getStudentApplyList(params) {
    return api.post(baseUrl + `api/enterprise/school_job/apply/list`, params)
  },
  getResumesNum(params) {
    return api.get(baseUrl + `api/enterprise/job_apply/count`, params)
  },
  getStuByCom(params) {
    return api.post(baseUrl + `api/enterprise/enterprise_job/apply/list`, params)
  },
  getAllResumes(params) {
    return api.post(baseUrl + `api/enterprise/job_apply/list`, params)
  },
  updateDeliveryStatus(id, params) {
    return api.post(baseUrl + `api/enterprise/school_job/apply/update/${id}`, params)
  },
  updateDeliveryStatusByCom(id, params) {
    return api.post(baseUrl + `api/enterprise/enterprise_job/apply/update/${id}`, params)
  },
  // 查看学生投递
  getAllResume(params) {
    return api.post(baseUrl + "api/enterprise/job/apply/list", params);
  }
}